import { Menu } from "lucide-react";

import { ScopeSelector } from "@/components/layout/scope-selector";
import { SyncButton } from "@/components/layout/sync-button";
import { UserMenu } from "@/components/layout/user-menu";
import { Logo } from "@/components/ui/logo";
import { formatDateLong } from "@/lib/format";

export function Topbar({ onOpenMenu }: { onOpenMenu: () => void }) {
  const raw = formatDateLong(new Date(), { weekday: true });
  const today = raw.charAt(0).toUpperCase() + raw.slice(1);
  return (
    <header className="flex min-h-[100px] flex-col gap-4 border-b border-[#dfe3eb] bg-white px-4 py-4 dark:border-[#2e3336] dark:bg-[#101315] sm:px-6 lg:flex-row lg:items-center lg:justify-between lg:px-8">
      <div className="flex items-center justify-between gap-4">
        <div className="flex items-center gap-3 xl:hidden">
          <button
            aria-label="Abrir menú"
            className="grid h-10 w-10 place-items-center rounded-full border border-[#dfe3eb] dark:border-[#3f4548]"
            onClick={onOpenMenu}
            type="button"
          >
            <Menu className="h-5 w-5" />
          </button>
          <Logo markClassName="h-9 w-9" textClassName="text-2xl dark:text-white" />
        </div>
        <p className="hidden text-sm font-bold xl:block">{today}</p>
      </div>
      <div className="flex flex-1 flex-wrap items-center justify-between gap-3 sm:justify-end">
        <ScopeSelector />
        <div className="flex items-center gap-3">
          <SyncButton />
          <UserMenu />
        </div>
      </div>
    </header>
  );
}
